import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Box, Typography } from "@mui/material";

interface EmployeePiChartProps {
  employee?: any;
}

const COLORS: any = {
  Active: "#4ADE80",
  Invited: "#0A84FF",
  Pending: "#F79319",
};

const EmployeePiChart = ({ employee }: EmployeePiChartProps) => {
  const chartData = employee?.statuses
    ? Object.entries(employee.statuses).map(([name, status]: [string, any]) => ({
      name,
      value: Number(status.count) || 0,
    }))
    : [{ name: "Placeholder", value: 1 }];

  return (
    <Box sx={{ width: 120, height: 120, position: "relative" }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            innerRadius={50}
            outerRadius={60}
            paddingAngle={2}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
            cornerRadius={4}
            stroke="none"
          >
            {chartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[entry.name] || "#333"}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="h4"
          component="div"
          style={{ fontSize: "24px", fontWeight: "bold", color: "#fff" }}
        >
          {employee?.total || 0}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmployeePiChart;
